import React from "react";
import { toast } from "react-toastify";
import { Modal, Button, Alert } from "@/Components/Common/Tailwind";
import { API, BACKEND_HOST } from "../../api";
import { getAccessToken } from "../../api/auth";

interface Option {
  name: string;
  type: string;
}

interface ReservationCheckoutInfo {
  id: number;
  gift_state: boolean;
  name: string;
  reservationDate: string;
  reservationEndDate?: string;
  spot: number;
  options: Option[];
  state: string;
}

interface ReservationCheckoutModalProps {
  info: ReservationCheckoutInfo;
  setInfo: (info: ReservationCheckoutInfo | {}) => void;
  visible: boolean;
  setVisible: (visible: boolean) => void;
  needRefresh: () => void;
}

const ReservationCheckoutModal = (props: ReservationCheckoutModalProps) => {
  const [checkModal, setCheckModal] = React.useState(false);
  const { info } = props;

  const togModal = () => {
    props.setVisible(!props.visible);
  };

  const togCheckModal = () => {
    setCheckModal(!checkModal);
  };


  const changeReserv = async () => {
    const accessToken = getAccessToken();

    try {
      const response = await API.post(
        "/package/change-reservation/",
        {
          id: info.id,
          reservation: "퇴장",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      const data = response.data;
      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };



  const changeReservGift = async () => {
    const accessToken = getAccessToken();

    try {
      const response = await API.put(
        `/package/checkout-reservation-gift/${info.id}/`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      const data = response.data;
      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  return (
    <React.Fragment>
      <Modal toggle={togModal} isOpen={props.visible} centered>
        <div>
          <div className="mb-4 flex justify-center">
            <h4 className="text-lg font-semibold">체크아웃 확인 {info.gift_state ? "(선물)" : null}</h4>
          </div>
          <ul className="list-group">
            {/* <li className="list-group-item">예약ID : {info.id}</li> */}
            <li className="list-group-item">
              <span className="font-semibold w-24 inline-block">예약상품 :</span>
              <span>{info.name}</span>
            </li>

            {info.reservationEndDate && info.reservationDate === info.reservationEndDate ?
              <li className="list-group-item">
                <span className="font-semibold w-24 inline-block">예약일 :</span>
                <span>{info.reservationDate}</span>
              </li> :
              <li className="list-group-item">
                <span className="font-semibold w-24 inline-block">예약일 :</span>
                <span>{info.reservationDate} ~ {info.reservationEndDate}</span>
              </li>}

            <li className="list-group-item">
              <span className="font-semibold w-24 inline-block">자리 :</span>
              <span>{info.spot}</span>
            </li>
            {info.options && info.options.length ? (
              <li className="list-group-item">
                <span className="font-semibold w-24 inline-block">옵션: </span>
                {info.options.map((item, idx, obj) => {
                  return (
                    <span key={idx}>
                      {item.name}
                      {idx !== obj.length - 1 ? ", " : ""}
                    </span>
                  );
                })}
              </li>
            ) : null}
            <li className="list-group-item">
              <span className="font-semibold w-24 inline-block">상태 :</span>
              <span>{info.state}</span>
            </li>
          </ul>
          <div className="my-3 flex justify-center">
            <span>체크아웃 요청 후 승인완료가 되면 더 이상 자리를 이용할 수 없습니다.</span>
          </div>
          {info.options && info.options.find((item) => item.type === "deposit") ? (
            <div>
              <p className="text-center font-medium">
                체크아웃을 원하시면 ‘체크아웃 요청’을 누른 후, 체크아웃이 승인될 때까지 자리에서 잠시 대기해 주세요.
                <br />
                <span className="text-red-500">관리자가 청결 상태 확인 후 체크아웃을 승인합니다. 이후 최초 지불 되었던 청소보증금은 환불됩니다.</span>
              </p>
            </div>
          ) : null}
        </div>
        <div className="flex justify-center gap-2 mt-4">
          <Button
            variant="secondary"
            onClick={() => {
              props.setInfo({});
              props.setVisible(!props.visible);
            }}
          >
            닫기
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              if (!info.gift_state) {
                changeReserv()
                  .then((obj) => {
                    toast.error("예약 상태가 변경되었습니다!");
                    props.needRefresh();
                  })
                  .catch((err) => {
                    toast.error("예약 상태 변경에 실패하였습니다!");
                    console.log(err);
                  });
              } else {
                changeReservGift()
                  .then((obj) => {
                    console.log(obj);
                    if (obj.error) {
                      toast.error("예약(선물) 상태 변경에 실패하였습니다!");
                      return;
                    } else {
                      toast.error("예약(선물) 상태가 변경되었습니다!");
                    }
                    props.needRefresh();
                  })
                  .catch((err) => {
                    toast.error("예약(선물) 상태 변경에 실패하였습니다!");
                    console.log(err);
                  });
              }
              props.setVisible(!props.visible);
            }}
          >
            체크아웃
          </Button>
        </div>
      </Modal>
    </React.Fragment>
  );
};
export default ReservationCheckoutModal;
